import request from '@/api/http.js'

export function columnInsert(data) {
    return request({
        url: '/cms/column/insert',
        method: 'post',
        data,
    })
}


export function columnList(data) {
    return request({
        url: '/cms/column/list',
        method: 'get',
        params: data,
    })
}



export function columnAddOrUpdate(data) {
    return request({
        url: '/cms/column/addOrUpdate',
        method: 'post',
        data,
    })
}

export function columnDelete(data) {
    return request({
        url: '/cms/column/delete',
        method: 'post',
        data,
    })
}

export function articleAddOrUpdate(data) {
    return request({
        url: '/cms/article/addOrUpdate',
        method: 'post',
        data,
    })
}

export function articleDelete(data) {
    return request({
        url: '/cms/article/delete',
        method: 'post',
        data,
    })
}

export function articleInsert(data) {
    return request({
        url: '/cms/article/insert',
        method: 'post',
        data,
    })
}

export function deleteFile(data) {
    return request({
        url: '/cms/article/deleteFile',
        method: 'post',
        data,
    })
}


export function articleDetail(data) {
    return request({
        url: '/cms/article/detail',
        method: 'get',
        params: data,
    })
}

export function articleImport(params,data) {
    return request({
        url: '/cms/article/import',
        method: 'post',
        params: params,
        data
    })
}

